import _ from 'lodash';
import React, { Component } from 'react';
import { Button } from 'antd';
import api from '../../api';
import helpers from '../../helpers'
import AppConfig from '../../config';
import FaIcon from '../global/fa-icon/fa-icon';



class PublishActions extends Component {

  constructor(props) {
    super(props);

    this.onPreviewClicked = this.onPreviewClicked.bind(this);
    this.onPublishClicked = this.onPublishClicked.bind(this);
    this.onViewLiveSiteClicked = this.onViewLiveSiteClicked.bind(this);
  }

  async onPreviewClicked() {
    let publishData = await helpers.publish.createRecentlyPublishedSchedulesData();
    // console.log('preview showtimes data');
    // console.log(JSON.stringify(publishData));

    let res = await api.publish.publishPreview(publishData);
    let resData = _.get(res, 'data');
    let previewPath = _.get(resData, 'publishPath') || '';

    let url = _.get(AppConfig, 'app.url') + '?preview=' + previewPath;
    window.open(url, 'ubadmin-preview');
  }

  async onPublishClicked() {
    let publishData = await helpers.publish.createRecentlyPublishedSchedulesData();
    // console.log('published showtimes data');
    // console.log(JSON.stringify(publishData));

    await api.publish.publishFinal(publishData);

    let url = _.get(AppConfig, 'app.url') ;
    window.open(url, 'ubadmin-publish');
  }

  async onViewLiveSiteClicked() {
    let url = _.get(AppConfig, 'app.url') ;
    window.open(url, 'ubadmin-view');
  }

  render() {
    return (
      <div className="publish-actions">
        <Button size="large" className="btn-secondary publish-button" icon={<FaIcon icon="fa-browser" />} onClick={this.onViewLiveSiteClicked}>Live Site</Button>
        <Button size="large" className="btn-secondary publish-button" icon={<FaIcon icon="fa-laptop" />} onClick={this.onPreviewClicked}>Preview</Button>
        <Button size="large" className="btn-success publish-button" icon={<FaIcon icon="fa-upload" />} onClick={this.onPublishClicked}>Publish</Button>
      </div>
    );
  }
}

export default PublishActions;

